AllWaysPayWinAnimator = {};
AllWaysPayWinAnimator.animationPool = [];
AllWaysPayWinAnimator.currentAnimations = [];
AllWaysPayWinAnimator.winBoxYTweak = 0;
AllWaysPayWinAnimator.symbolwinOffsetX = 0;
AllWaysPayWinAnimator.symbolwinOffsetY = -0;
AllWaysPayWinAnimator.gameReels = undefined;

AllWaysPayWinAnimator.offsetY = -10;

AllWaysPayWinAnimator.ready = false;

AllWaysPayWinAnimator.initialise = function () {
  AllWaysPayWinAnimator.animationPool = [
    {
      poolName: "Jack",
      number: 0,
      pool: [],
    },
    {
      poolName: "Queen",
      number: 0,
      pool: [],
    },
    {
      poolName: "King",
      number: 0,
      pool: [],
    },
    {
      poolName: "Ace",
      number: 0,
      pool: [],
    },
    {
      poolName: "Lamp",
      number: 0,
      pool: [],
    },
    {
      poolName: "Silver",
      number: 0,
      pool: [],
    },
    {
      poolName: "BlueGem",
      number: 0,
      pool: [],
    },
    {
      poolName: "GreenGem",
      number: 0,
      pool: [],
    },
    {
      poolName: "RedGem",
      number: 0,
      pool: [],
    },
    {
      poolName: "Diamond",
      number: 0,
      pool: [],
    },
    {
      poolName: "Wild",
      number: 0,
      pool: [],
    },
    {
      poolName: "Barrel",
      number: 0,
      pool: [],
    },
    {
      poolName: "Cart",
      number: 0,
      pool: [],
    },
    {
      poolName: "Bonus",
      number: 0,
      pool: [],
    },
    {
      poolName: "symbolWin",
      number: 0,
      pool: [],
    },
  ];

  for (let i = 0; i < 3; i++) {
    AllWaysPayWinAnimator.createAnim("Jack", i);
    AllWaysPayWinAnimator.createAnim("Queen", i);
    AllWaysPayWinAnimator.createAnim("King", i);
    AllWaysPayWinAnimator.createAnim("Ace", i);
    AllWaysPayWinAnimator.createAnim("Lamp", i);
    AllWaysPayWinAnimator.createAnim("Silver", i);
    AllWaysPayWinAnimator.createAnim("BlueGem", i);
    AllWaysPayWinAnimator.createAnim("GreenGem", i);
    AllWaysPayWinAnimator.createAnim("RedGem", i);
    AllWaysPayWinAnimator.createAnim("Diamond", i);
    AllWaysPayWinAnimator.createAnim("Wild", i);
    AllWaysPayWinAnimator.createAnim("Barrel", i);
    AllWaysPayWinAnimator.createAnim("Cart", i);
    AllWaysPayWinAnimator.createAnim("Bonus", i);
    AllWaysPayWinAnimator.createAnim("symbolWin", i);
  }

  AllWaysPayWinAnimator.gameReels = gameData.reels;

  AllWaysPayWinAnimator.ready = true;

  messageBus.subscribe("spinner:SpinEvent", AllWaysPayWinAnimator.doSpin);
  messageBus.subscribe("spinner:ReSpinEvent", AllWaysPayWinAnimator.doSpin);
};

AllWaysPayWinAnimator.doSpin = function (spinTask) {
  AllWaysPayWinAnimator.reels = spinTask.data.resultPanel.reelList;
};

AllWaysPayWinAnimator.createAnim = function (
  name,
  index,
  poolIndex = undefined
) {
  let anim = undefined;

  if (name === "symbolWin") {
    anim = resourceManager.createObject(
      "movie",
      name + "_" + index,
      "slotContainer:symbolWinBorderAnim",
      {
        definition: name,
        anchor: 0.5,
      }
    );
  } else {
    anim = resourceManager.createObject(
      "movie",
      name + "_" + index,
      "slotContainer:reelContainer:foregroundReelSymbols",
      {
        definition: name,
        anchor: 0.5,
      }
    );
  }

  anim.loop = false;
  anim.gotoAndStop(0);
  anim.visible = false;

  if (poolIndex === undefined) {
    for (let i = 0; i < AllWaysPayWinAnimator.animationPool.length; i++) {
      let poolType = AllWaysPayWinAnimator.animationPool[i];

      if (poolType.poolName === name) {
        poolType.pool.push(anim);
        poolType.number++;
      }
    }
  } else {
    AllWaysPayWinAnimator.animationPool[poolIndex].pool.push(anim);
    AllWaysPayWinAnimator.animationPool[poolIndex].number++;
  }

  return anim;
};

AllWaysPayWinAnimator.positionAnim = function (animationObject) {
  const reels = AllWaysPayWinAnimator.gameReels;
  const anim = animationObject.anim;
  const reel = animationObject.reel;
  const row = animationObject.row;

  const x = reels[reel].position.getX() - 12;
  const y =
    reels[reel].position.getY() + row * reels[reel].Props.appertureSpacing - 10;

  anim.position.set(x, y);
};

AllWaysPayWinAnimator.animate = function (data, callback, singleWinCallback) {
  AllWaysPayWinAnimator.wins = [];
  AllWaysPayWinAnimator.highestSymbol = 0;

  let wins = [];

  if (data.payWays5X.payWaysWins.length > 0) {
    wins.push(...data.payWays5X.payWaysWins);
  }
  if (data.payWaysLeft.payWaysWins.length > 0) {
    wins.push(...data.payWaysLeft.payWaysWins);
  }
  if (data.payWaysRight.payWaysWins.length > 0) {
    wins.push(...data.payWaysRight.payWaysWins);
  }

  wins.forEach(function (win) {
    const winSymbol = win.symbol;
    if (winSymbol > AllWaysPayWinAnimator.highestSymbol) {
      AllWaysPayWinAnimator.highestSymbol = winSymbol;
    }
    win.winSymPositions.forEach(function (symbol) {
      AllWaysPayWinAnimator.wins.push(symbol);
    });
  });

  for (var i = 0; i < reelManager.reels.length; i++) {
    reelManager.reels[i].dimAllSymbols(true, 0x666666);
  }

  AllWaysPayWinAnimator.singleWinCallback = singleWinCallback;

  AllWaysPayWinAnimator.finishedCallback = callback;

  AllWaysPayWinAnimator.animateNextWin();
};

AllWaysPayWinAnimator.animateSymbolWithoutBorder = function (
  symMovieName,
  reel,
  row
) {
  let animation = AllWaysPayWinAnimator.findAnimation(symMovieName);

  let animationObject = {
    anim: animation,
    reel: reel,
    row: row,
  };

  AllWaysPayWinAnimator.currentAnimations.push(animationObject);

  animation.onComplete = function () {
    AllWaysPayWinAnimator.animationFinished(animationObject);
    AllWaysPayWinAnimator.returnToPool(symMovieName, animation);
  };

  AllWaysPayWinAnimator.positionAnim(animationObject);

  animation.visible = true;
  animation.gotoAndPlay(0);
};

AllWaysPayWinAnimator.animateSymbol = function (symMovieName, reel, row) {
  let animation = AllWaysPayWinAnimator.findAnimation(symMovieName);
  let symbolWinAnim = AllWaysPayWinAnimator.findAnimation("symbolWin");

  let animationObject = {
    anim: animation,
    reel: reel,
    row: row,
  };

  let symbolWinObject = {
    anim: symbolWinAnim,
    reel: reel,
    row: row,
  };

  AllWaysPayWinAnimator.currentAnimations.push(animationObject);
  AllWaysPayWinAnimator.currentAnimations.push(symbolWinObject);

  symbolWinAnim.onComplete = function () {
    AllWaysPayWinAnimator.animationFinished(animationObject);
    AllWaysPayWinAnimator.animationFinished(symbolWinObject);
    AllWaysPayWinAnimator.returnToPool(symMovieName, animation);
    AllWaysPayWinAnimator.returnToPool("symbolWin", symbolWinAnim);
  };

  AllWaysPayWinAnimator.positionAnim(animationObject);
  AllWaysPayWinAnimator.positionAnim(symbolWinObject);

  if (gameController.canCelebrate || freespins.inFreespins) {
    animation.visible = true;
    animation.gotoAndPlay(0);
  }

  symbolWinAnim.visible = true;
  symbolWinAnim.gotoAndPlay(0);
};

AllWaysPayWinAnimator.findAnimation = function (symMovieName) {
  let animation = undefined;
  let location = 0;
  let number = 0;

  for (let i = 0; i < AllWaysPayWinAnimator.animationPool.length; i++) {
    let poolType = AllWaysPayWinAnimator.animationPool[i];

    if (poolType.poolName === symMovieName) {
      number = poolType.number;
      location = i;

      if (poolType.pool.length > 0) {
        animation = poolType.pool[0];
        poolType.pool.splice(0, 1);
        return animation;
      }
    }
  }

  animation = AllWaysPayWinAnimator.createAnim(symMovieName, number + 1);
  AllWaysPayWinAnimator.animationPool[location].pool.pop();
  return animation;
};

AllWaysPayWinAnimator.returnToPool = function (name, animation) {
  for (let i = 0; i < AllWaysPayWinAnimator.animationPool.length; i++) {
    let poolType = AllWaysPayWinAnimator.animationPool[i];

    if (poolType.poolName === name) {
      poolType.pool.push(animation);
    }
  }
};

AllWaysPayWinAnimator.animateNextWin = function () {
  const symbolInfo = resourceManager.getConfiguration().symbols;
  const symInfoId = Object.keys(symbolInfo).find(function (key) {
    return AllWaysPayWinAnimator.highestSymbol === symbolInfo[key].ID;
  });

  if (AllWaysPayWinAnimator.currentAnimations.length > 0) {
    AllWaysPayWinAnimator.skip();
  }

  soundManager.play(symbolInfo[symInfoId].soundFile);

  AllWaysPayWinAnimator.currentAnimations = [];
  AllWaysPayWinAnimator.wins.forEach(function (symbol) {
    let symbolName = Object.keys(resourceManager.getConfiguration().symbols)[
      symbol.sym
    ];

    reelManager.reels[symbol.reel].dimSymbol(symbol.row, false);

    AllWaysPayWinAnimator.animateSymbol(symbolName, symbol.reel, symbol.row);
  });
};

AllWaysPayWinAnimator.animationFinished = function (animationObject) {
  if (animationObject !== undefined) {
    animationObject.anim.gotoAndStop(0);
    animationObject.anim.visible = false;
    AllWaysPayWinAnimator.currentAnimations.splice(
      AllWaysPayWinAnimator.currentAnimations.indexOf(animationObject),
      1
    );
  }

  if (AllWaysPayWinAnimator.currentAnimations.length === 0) {
    if (AllWaysPayWinAnimator.finishedCallback) {
      AllWaysPayWinAnimator.finishedCallback();
    }
  }

  if (AllWaysPayWinAnimator.singleWinCallback) {
    AllWaysPayWinAnimator.singleWinCallback();
  }

  for (var i = 0; i < reelManager.reels.length; i++) {
    reelManager.reels[i].dimAllSymbols(false, 0x666666);
  }
};

AllWaysPayWinAnimator.skip = function () {
  AllWaysPayWinAnimator.currentAnimations.forEach((animation) => {
    animation.anim.gotoAndStop(0);
    animation.anim.visible = false;
  });

  for (var i = 0; i < reelManager.reels.length; i++) {
    reelManager.reels[i].dimAllSymbols(false, 0x666666);
  }

  AllWaysPayWinAnimator.currentAnimations = [];

  if (AllWaysPayWinAnimator.finishedCallback) {
    AllWaysPayWinAnimator.finishedCallback();
  }

  if (AllWaysPayWinAnimator.singleWinCallback) {
    AllWaysPayWinAnimator.singleWinCallback();
  }
};

AllWaysPayWinAnimator.onOrientationChange = function () {
  if (AllWaysPayWinAnimator.ready) {
    AllWaysPayWinAnimator.currentAnimations.forEach((animationObject) => {
      AllWaysPayWinAnimator.positionAnim(animationObject);
    });
  }
};

AllWaysPayWinAnimator.onReady = function () {
  // AllWaysPayWinAnimator.ready = true;
};

Reflex.registerEventHandler(
  "layoutChange",
  AllWaysPayWinAnimator.onOrientationChange
);
Reflex.registerEventHandler("ready", AllWaysPayWinAnimator.onReady);
